export var ExchangePairTypeEnum;
(function (ExchangePairTypeEnum) {
    ExchangePairTypeEnum["STABLE_STABLE"] = "STABLE_STABLE";
    ExchangePairTypeEnum["NON_STABLE_STABLE"] = "NONSTABLE_STABLE";
})(ExchangePairTypeEnum || (ExchangePairTypeEnum = {}));
//# sourceMappingURL=exchange-pair-type.enum.js.map